import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=32531a8b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/UnderConstruction.vue
// module id = 1590
// module chunks = 0